var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"}),_vm._v(" "),(!!_vm.message)?_c('div',{staticClass:"lr-loader-msg"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e95603e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/Loader.vue
// module id = 853
// module chunks = 0